"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Add2 = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Bookmark2 = _interopRequireDefault(require("@mui/icons-material/Bookmark"));
var _Hotel2 = _interopRequireDefault(require("@mui/icons-material/Hotel"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Phone2 = _interopRequireDefault(require("@mui/icons-material/Phone"));
var _Email2 = _interopRequireDefault(require("@mui/icons-material/Email"));
var _Public2 = _interopRequireDefault(require("@mui/icons-material/Public"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _accueilVelo = _interopRequireDefault(require("../../assets/images/poi/accueil-velo.png"));
var _hooks = require("../../hooks");
var _button = require("../button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PoiPopup(_ref, ref) {
  let {
    theme,
    categories: _categories,
    search,
    poiAnnotationsMap,
    poi,
    selectedTripStep: _selectedTripStep,
    widgetConfig,
    onSearchUpdated,
    onAddAsRideStep,
    onRemoveFromRideSteps,
    onPoiAddedToTripStep,
    onPoiRemovedFromTripStep,
    onTripStepAccomodationSelected,
    onTripStepAccomodationUnselected,
    onClose,
    enqueueSnackbar
  } = _ref;
  const [poiAnnotation, setPoiAnnotation] = (0, _react.useState)();
  const [selectedTripStep, selectTripStep] = (0, _react.useState)(_selectedTripStep);
  const [updatingTripStep, updateTripStep] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    copy: copyToClipboard
  } = (0, _hooks.useClipboard)(() => enqueueSnackbar?.(t('commons.phone_copied_to_clipboard')), () => enqueueSnackbar?.(t('commons.failed_to_copy_phone_to_clipboard')));
  (0, _react.useEffect)(() => {
    getPoiAnnotation();
  }, [selectedTripStep, poiAnnotationsMap]);
  function getPoiAnnotation() {
    if (!poiAnnotationsMap || !selectedTripStep || !selectedTripStep.poiAnnotationIds) return;
    const poiAnnotationId = selectedTripStep.poiAnnotationIds.find(id => {
      const poiAnnotation = poiAnnotationsMap[id];
      if (!poiAnnotation) return false;
      const {
        source,
        poi: {
          id: poiId,
          externalId
        }
      } = poiAnnotation;
      return source === 'geovelo' ? poiId === poi.id : externalId === poi.externalId;
    });
    setPoiAnnotation(poiAnnotationId && poiAnnotationsMap[poiAnnotationId] || null);
  }
  (0, _react.useImperativeHandle)(ref, () => ({
    update: (_poiAnnotationsMap, _selectedTripStep) => {
      if (selectedTripStep && selectedTripStep.id === _selectedTripStep.id) {
        selectTripStep(_selectedTripStep);
        updateTripStep(false);
      }
    }
  }));
  const {
    title: _title,
    location,
    description,
    photos,
    categoryCodes,
    detailsUrl,
    website,
    phone,
    email,
    bicycleHome,
    isAccomodation
  } = poi;
  const photo = photos[0];
  const hasCategory = {};
  let categories = _categories.reduce((res, category) => {
    const {
      code,
      labelKey
    } = category;
    if (labelKey && categoryCodes.indexOf(code) > -1 && !hasCategory[labelKey]) {
      res.push(category);
      hasCategory[labelKey] = true;
    }
    return res;
  }, []);
  let title = _title;
  if (!_title) {
    const category = categories[0];
    if (category && category.labelKey) {
      title = t(category.labelKey, {
        context: 'one'
      });
      categories = categories.slice(1);
    }
  }
  const inTripStep = selectedTripStep && poiAnnotation && selectedTripStep.poiAnnotationIds ? selectedTripStep.poiAnnotationIds.indexOf(poiAnnotation.id) > -1 || selectedTripStep.departureAccomodationAnnotationId === poiAnnotation.id || selectedTripStep.arrivalAccomodationAnnotationId === poiAnnotation.id : false;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), photo && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "top",
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, photo.title, " ", photo.copyright && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA9 ", photo.copyright))
  }, /*#__PURE__*/_react.default.createElement(StyledPhotoWrapper, {
    url: photo.thumbnailUrl || ''
  })), /*#__PURE__*/_react.default.createElement(StyledHeader, {
    className: photo ? '' : 'shifted'
  }, bicycleHome && /*#__PURE__*/_react.default.createElement(StyledHeaderLogo, {
    title: "Accueil v\xE9lo",
    url: _accueilVelo.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, detailsUrl ? /*#__PURE__*/_react.default.createElement(StyledTitle, {
    color: "secondary",
    component: "a",
    href: detailsUrl,
    target: "_blank",
    title: title || '',
    variant: "h6"
  }, title) : /*#__PURE__*/_react.default.createElement(StyledTitle, {
    title: title || '',
    variant: "h6"
  }, title), categories.length > 0 && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, categories.map((_ref2, index) => {
    let {
      id,
      labelKey
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: id
    }, index > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0\u2022\xA0"), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: labelKey,
      values: {
        context: 'one'
      }
    }));
  })))), (website || email || phone) && /*#__PURE__*/_react.default.createElement(StyledActions, null, website && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "right",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.website"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    color: "primary",
    component: "a",
    href: website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Public2.default, null))), email && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "right",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.email"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    color: "primary",
    component: "a",
    href: `mailto:${email}`,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Email2.default, null))), phone && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "right",
    title: phone
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    color: "primary",
    onClick: () => copyToClipboard(phone),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Phone2.default, null)))), description && /*#__PURE__*/_react.default.createElement(StyledContent, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    component: "p",
    variant: "caption"
  }, widgetConfig?.code === 'lav' && detailsUrl && description.length > 150 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, description.slice(0, 150).trim(), "...", ' ', /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "secondary",
    component: "a",
    href: detailsUrl,
    target: "_blank",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.see_details"
  }))) : description)), search && onSearchUpdated && /*#__PURE__*/_react.default.createElement(StyledActions, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    onClick: () => {
      if (!search.wayPoints[0]) search.wayPoints.splice(0, 1, location.clone());else search.wayPoints.splice(0, 0, location.clone());
      onSearchUpdated();
      onClose();
    },
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.leave_from_here"
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexGrow: 1
  }), /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    onClick: () => {
      if (!search.wayPoints[1]) search.wayPoints.splice(1, 1, location.clone());else search.wayPoints.push(location.clone());
      onSearchUpdated();
      onClose();
    },
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.go_there"
  }))), onAddAsRideStep && !search?.wayPoints.find(wayPoint => wayPoint && wayPoint.id === `poi-${poi.id}`) && /*#__PURE__*/_react.default.createElement(StyledActions, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    onClick: () => {
      onAddAsRideStep(poi);
      onClose();
    },
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.add_as_step"
  }))), onRemoveFromRideSteps && search?.wayPoints.find(wayPoint => wayPoint && wayPoint.id === `poi-${poi.id}`) && /*#__PURE__*/_react.default.createElement(StyledActions, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    className: "dangerous",
    color: "error",
    onClick: () => {
      onRemoveFromRideSteps(poi);
      onClose();
    },
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.remove_from_steps"
  }))), selectedTripStep && /*#__PURE__*/_react.default.createElement(StyledActions, null, isAccomodation ? inTripStep ? /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: updatingTripStep,
    onClick: () => {
      if (poiAnnotation) onTripStepAccomodationUnselected?.(poiAnnotation);
      updateTripStep(true);
      onClose();
    },
    startIcon: updatingTripStep ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_Hotel2.default, {
      color: "primary"
    }),
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.trip.actions.remove_accomodation"
  })) : /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    disabled: updatingTripStep,
    onClick: () => {
      onTripStepAccomodationSelected?.(poi);
      updateTripStep(true);
      onClose();
    },
    startIcon: updatingTripStep ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_Hotel2.default, null),
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.trip.actions.add_accomodation"
  })) : inTripStep ? /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: updatingTripStep,
    onClick: () => {
      if (poiAnnotation) onPoiRemovedFromTripStep?.(poiAnnotation);
      updateTripStep(true);
    },
    startIcon: updatingTripStep ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_Bookmark2.default, {
      color: "primary"
    }),
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.trip.actions.to_visit"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: updatingTripStep,
    onClick: () => {
      onPoiAddedToTripStep?.(poi);
      updateTripStep(true);
    },
    startIcon: updatingTripStep ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_Bookmark2.default, null),
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.trip.actions.to_visit"
  })), /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    disabled: updatingTripStep,
    onClick: () => {
      if (onPoiAddedToTripStep) onPoiAddedToTripStep(poi, true);
      onClose();
    },
    startIcon: /*#__PURE__*/_react.default.createElement(_Add2.default, null),
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.trip.actions.add_step"
  }))))));
}
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  max-height: max(calc(50vh - 24px), 400px);
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 350px);
`;
const CloseButtonWrapper = _styledComponents.default.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledPhotoWrapper = _styledComponents.default.div`
  background-color: whitesmoke;
  background-image: ${_ref3 => {
  let {
    url
  } = _ref3;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex-shrink: 0;
  height: 175px;
`;
const StyledHeader = _styledComponents.default.div`
  display: flex;
  flex-shrink: 0;
  padding: 16px 16px 8px 16px;

  &.shifted {
    padding: 16px 54px 8px 16px;
  }
`;
const StyledHeaderLogo = _styledComponents.default.div`
  align-self: center;
  background-image: ${_ref4 => {
  let {
    url
  } = _ref4;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const StyledTitle = (0, _styledComponents.default)(_Typography2.default)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledContent = _styledComponents.default.div`
  flex-shrink: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
`;
const StyledActions = _styledComponents.default.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 8px;
  height: 48px;
  padding: 0 16px;
`;
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(PoiPopup);